export const SUPER_ROLES = ['head', 'academic_head', 'director', 'admin'];
export const MODULES = [
  ['/', 'Daily Ops', 'accessDailyOps', 'Operations'],
  ['/my-tasks', 'My Tasks', 'accessMyTasks', 'Operations'],
  ['/floor-plan-ops', 'Floor Plan', 'accessFloorPlan', 'Operations'],
  ['/attendance', 'Attendance', 'accessAttendance', 'Academics'],
  ['/students', 'Students', 'accessStudents', 'Academics'],
  ['/faculty-timing', 'Faculty Timing', 'accessFacultyTiming', 'Academics'],
  ['/schedule', 'Syllabus Tracker', 'accessSchedule', 'Academics'],
  ['/schedule-builder', 'Schedule Builder', 'accessSchedule', 'Academics'],
  ['/exams', 'Exams', 'accessExams', 'Academics'],
  ['/feedback-builder', 'Feedback Forms', 'accessFeedbackBuilder', 'Academics'],
  ['/reports', 'Reports', 'accessReports', 'Academics'],
  ['/issues', 'Tickets', 'accessIssues', 'Operations'],
  ['/allocate-tickets', 'Ticket Manager Desk', 'accessIssues', 'Operations'],
  ['/ir-manager', 'IR Manager', 'accessIR', 'Operations'],
  ['/results-service', 'Results Service', 'accessResultsService', 'Operations'],
  ['/result-posters', 'Result Posters', 'accessResultPosters', 'Operations'],
  ['/user-addition', 'User Addition', 'accessUserAddition', 'Operations'],
  ['/sales-service', 'Sales', 'accessSales', 'Sales'],
  ['/sales-form-builder', 'Ad Forms', 'accessSales', 'Sales'],
  ['/marketing-travel', 'Travel Log', 'accessSales', 'Sales'],
  ['/finance', 'Finance', 'accessFinance', 'Finance'],
  ['/finance-reimbursements', 'Reimbursements', 'accessFinance', 'Finance'],
  ['/finance-budgets', 'Budgeting & Variance', 'accessFinance', 'Finance'],
  ['/finance-config', 'Finance Config', 'accessFinanceConfig', 'Finance'],
  ['/director-settings', 'Signature Settings', 'directorOnly', 'Finance'],
  ['/hr-dashboard', 'HR Dashboard', 'accessHR', 'People'],
  ['/my-portal', 'My Portal', 'accessEmployeePortal', 'People'],
  ['/prp-manager', 'PRP Manager', 'accessPRP', 'People'],
  ['/users', 'Manage Team', 'accessUserManagement', 'People'],
  ['/audit-trail', 'Audit Trail', 'accessAuditTrail', 'Administration'],
  ['/settings/tasks', 'Task Settings', 'accessUserManagement', 'Operations'],
].map(([path, label, feature, group]) => ({ path, label, feature, group }));

export function allowedModules(role, permissions = {}) {
  const staff = ['head','academic_head','director','admin','manager','tl','accountant','employee'].includes(role) || Object.values(permissions).some(v => v === true);
  return MODULES.filter(item => {
    if (item.path === '/result-posters') return SUPER_ROLES.includes(role) || (permissions.accessResultPosters === true && permissions.accessResultsService === true);
    if (['/finance-reimbursements', '/finance-budgets'].includes(item.path)) return ['director','accountant'].includes(role);
    if (['/finance-config','/director-settings'].includes(item.path)) return role === 'director';
    if (item.path === '/finance' && role === 'accountant') return true;
    return item.feature === 'accessAuditTrail' ? permissions.accessAuditTrail === true : (role === 'manager' && item.path === '/users') || (staff && ['/issues','/my-tasks'].includes(item.path)) || SUPER_ROLES.includes(role) || (item.feature !== 'directorOnly' && permissions[item.feature] === true);
  });
}
